/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ScoringStrategy } from './ScoringStrategy';
import {
    ScoringStrategyFromJSON,
    ScoringStrategyFromJSONTyped,
    ScoringStrategyToJSON,
    ScoringStrategyToJSONTyped,
} from './ScoringStrategy';
import type { HubChallengeConfigResponseEntryFeeRange } from './HubChallengeConfigResponseEntryFeeRange';
import {
    HubChallengeConfigResponseEntryFeeRangeFromJSON,
    HubChallengeConfigResponseEntryFeeRangeFromJSONTyped,
    HubChallengeConfigResponseEntryFeeRangeToJSON,
    HubChallengeConfigResponseEntryFeeRangeToJSONTyped,
} from './HubChallengeConfigResponseEntryFeeRange';

/**
 * Challenge-specific configuration for hub activities (decoupled from ArenaConfig)
 * @export
 * @interface SurfaceChallengeConfig
 */
export interface SurfaceChallengeConfig {
    /**
     * Scoring strategies allowed for hub challenges
     * @type {Array<ScoringStrategy>}
     * @memberof SurfaceChallengeConfig
     */
    allowedStrategies?: Array<ScoringStrategy>;
    /**
     * 
     * @type {ScoringStrategy}
     * @memberof SurfaceChallengeConfig
     */
    defaultStrategy?: ScoringStrategy;
    /**
     * Allowed structures (HEAD_TO_HEAD, FREE_FOR_ALL)
     * @type {Array<string>}
     * @memberof SurfaceChallengeConfig
     */
    allowedStructures?: Array<string>;
    /**
     * 
     * @type {HubChallengeConfigResponseEntryFeeRange}
     * @memberof SurfaceChallengeConfig
     */
    entryFeeRange?: HubChallengeConfigResponseEntryFeeRange;
    /**
     * Quick-select entry fee amounts
     * @type {Array<number>}
     * @memberof SurfaceChallengeConfig
     */
    presetEntryFees?: Array<number>;
    /**
     * How entry fee values are interpreted
     * @type {string}
     * @memberof SurfaceChallengeConfig
     */
    fuelPricingMode?: SurfaceChallengeConfigFuelPricingModeEnum;
    /**
     * Platform fee percentage (0-50)
     * @type {number}
     * @memberof SurfaceChallengeConfig
     */
    platformFeePercent?: number;
    /**
     * Fee structure (ADDON or DEDUCTION)
     * @type {string}
     * @memberof SurfaceChallengeConfig
     */
    feeStructure?: string;
    /**
     * ScoringTemplate ID auto-selected for challenges
     * @type {string}
     * @memberof SurfaceChallengeConfig
     */
    defaultScoringTemplateId?: string;
}


/**
 * @export
 */
export const SurfaceChallengeConfigFuelPricingModeEnum = {
    QTY: 'QTY',
    USD_EQUIVALENT: 'USD_EQUIVALENT'
} as const;
export type SurfaceChallengeConfigFuelPricingModeEnum = typeof SurfaceChallengeConfigFuelPricingModeEnum[keyof typeof SurfaceChallengeConfigFuelPricingModeEnum];


/**
 * Check if a given object implements the SurfaceChallengeConfig interface.
 */
export function instanceOfSurfaceChallengeConfig(value: object): value is SurfaceChallengeConfig {
    return true;
}

export function SurfaceChallengeConfigFromJSON(json: any): SurfaceChallengeConfig {
    return SurfaceChallengeConfigFromJSONTyped(json, false);
}

export function SurfaceChallengeConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfaceChallengeConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'allowedStrategies': json['allowedStrategies'] == null ? undefined : ((json['allowedStrategies'] as Array<any>).map(ScoringStrategyFromJSON)),
        'defaultStrategy': json['defaultStrategy'] == null ? undefined : ScoringStrategyFromJSON(json['defaultStrategy']),
        'allowedStructures': json['allowedStructures'] == null ? undefined : json['allowedStructures'],
        'entryFeeRange': json['entryFeeRange'] == null ? undefined : HubChallengeConfigResponseEntryFeeRangeFromJSON(json['entryFeeRange']),
        'presetEntryFees': json['presetEntryFees'] == null ? undefined : json['presetEntryFees'],
        'fuelPricingMode': json['fuelPricingMode'] == null ? undefined : json['fuelPricingMode'],
        'platformFeePercent': json['platformFeePercent'] == null ? undefined : json['platformFeePercent'],
        'feeStructure': json['feeStructure'] == null ? undefined : json['feeStructure'],
        'defaultScoringTemplateId': json['defaultScoringTemplateId'] == null ? undefined : json['defaultScoringTemplateId'],
    };
}

export function SurfaceChallengeConfigToJSON(json: any): SurfaceChallengeConfig {
    return SurfaceChallengeConfigToJSONTyped(json, false);
}

export function SurfaceChallengeConfigToJSONTyped(value?: SurfaceChallengeConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'allowedStrategies': value['allowedStrategies'] == null ? undefined : ((value['allowedStrategies'] as Array<any>).map(ScoringStrategyToJSON)),
        'defaultStrategy': ScoringStrategyToJSON(value['defaultStrategy']),
        'allowedStructures': value['allowedStructures'],
        'entryFeeRange': HubChallengeConfigResponseEntryFeeRangeToJSON(value['entryFeeRange']),
        'presetEntryFees': value['presetEntryFees'],
        'fuelPricingMode': value['fuelPricingMode'],
        'platformFeePercent': value['platformFeePercent'],
        'feeStructure': value['feeStructure'],
        'defaultScoringTemplateId': value['defaultScoringTemplateId'],
    };
}

